export enum AreaAdditionFormFields {
  defaultPrice = "defaultPrice",
  prices = "prices",
  skipCountSecondaryAreas = "skipCountSecondaryAreas",
}
